<template>
  <ButtonComponent type="button" class="kvass-media-types-vimeo-create-trigger">
    <span>Vimeo</span>
    <Icon :icon="['fab', 'vimeo']" class="ml-1"></Icon>
  </ButtonComponent>
</template>

<script>
import Icon from '@kvass/vue2-icon'
export default {
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.kvass-media-types-vimeo-create-trigger {
  padding: 1rem 0;

  svg {
    color: #00adef;
  }
}
</style>
